<template>
  <div class="foot">
    <div class="content">
      <div class="top">
        <router-link to="/" class="left">
          <img src="/logo.png" alt="" />
        </router-link>
        <div class="right">
          <div class="li" v-for="(item, index) in pageList" :key="index" @click="changePage(item)">
            {{ item.name }}
          </div>
        </div>
      </div>
      <div class="bottom">
        <div class="left">VoidChain - {{ i18n.Copyright }} - 2025</div>
        <div class="middle" @click="scrollToTop">
          <div class="dot"></div>
          {{ i18n.totop }}
        </div>
        <div class="right">
          <div v-for="social in socials" :key="social.name">
            <a class="social-icon" :href="social.link" target="_blank" rel="noopener noreferrer">
              <font-awesome-icon :icon="social.isBrand ? ['fab', social.icon] : social.icon" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DczxxFooter',
  data() {
    return {
      pageList: [],
      socials: [
        {
          name: 'Website',
          icon: 'globe',
          link: 'http://voidchain.net/',
          isBrand: false,
        },
        {
          name: 'GitHub',
          icon: 'github',
          link: 'https://github.com/voidchain-net',
          isBrand: true,
        },
        {
          name: 'LinkedIn',
          icon: 'linkedin',
          link: 'https://www.linkedin.com/company/voidchain/',
          isBrand: true,
        },
        {
          name: 'Telegram',
          icon: 'telegram',
          link: 'https://t.me/voidchainofficial',
          isBrand: true,
        },
        // {
        //   name: 'WeChat',
        //   icon: 'weixin',
        //   link: '#',
        //   isBrand: true,
        // },
        {
          name: 'X',
          icon: 'twitter',
          link: 'https://x.com/voidchainnet',
          isBrand: true,
        },
      ],
    }
  },
  computed: {
    i18n() {
      return this.$t('nav')
    },
  },
  watch: {
    '$i18n.locale'(newLang) {
      if (newLang === 'zh-CN') {
        this.pageList = [
          {
            id: 1,
            name: '解决方案',
            path: '/DevelopmentDocuments',
          },
          {
            id: 2,
            name: '区块查询',
            path: '/OnChainQuery',
          },
          {
            id: 3,
            name: '使用案例',
            path: '/DevelopmentDocuments',
          },
          {
            id: 4,
            name: '开发文档',
            path: '/DevelopmentDocuments',
          },
        ]
      } else if (newLang === 'en-US') {
        this.pageList = [
          {
            id: 1,
            name: 'Solution',
            path: '/DevelopmentDocuments',
          },
          {
            id: 2,
            name: 'Block query',
            path: '/OnChainQuery',
          },
          {
            id: 3,
            name: 'Use case',
            path: '/DevelopmentDocuments',
          },
          {
            id: 4,
            name: 'Development documents',
            path: '/DevelopmentDocuments',
          },
        ]
      }
    },
  },
  created() {
    if (this.$i18n.locale === 'zh-CN') {
      this.pageList = [
        {
          id: 1,
          name: '解决方案',
          path: '/DevelopmentDocuments',
        },
        {
          id: 2,
          name: '区块查询',
          path: '/OnChainQuery',
        },
        {
          id: 3,
          name: '使用案例',
          path: '/DevelopmentDocuments',
        },
        {
          id: 4,
          name: '开发文档',
          path: '/DevelopmentDocuments',
        },
      ]
    } else if (this.$i18n.locale === 'en-US') {
      this.pageList = [
        {
          id: 1,
          name: 'Solution',
          path: '/DevelopmentDocuments',
        },
        {
          id: 2,
          name: 'Block query',
          path: '/OnChainQuery',
        },
        {
          id: 3,
          name: 'Use case',
          path: '/DevelopmentDocuments',
        },
        {
          id: 4,
          name: 'Development documents',
          path: '/DevelopmentDocuments',
        },
      ]
    }
  },
  methods: {
    changePage(item) {
      if (item.path === this.$route.path) {
        console.log('已在当前页面', this.$route.path)
      } else {
        switch (item.id) {
          case 1:
            this.$router.push(item.path)
            sessionStorage.setItem('key', 5)
            this.$bus.$emit('brotherEvent', 5)
            break
          case 2:
            this.$router.push({ path: item.path, query: { id: 3 } })
            sessionStorage.setItem('key', 4)
            this.$bus.$emit('brotherEvent', 4)
            break
          case 3:
            this.$router.push(item.path)
            sessionStorage.setItem('key', 5)
            this.$bus.$emit('brotherEvent', 5)
            break
          case 4:
            this.$router.push(item.path)
            sessionStorage.setItem('key', 5)
            this.$bus.$emit('brotherEvent', 5)
            break

          default:
            break
        }
      }
    },
    golink(link) {
      window.open(link, '_blank')
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth', // 平滑滚动
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.foot {
  position: relative;
  z-index: 10000;
  .content {
    width: 100%;
    // height: 200px;
    border-top: 1px solid rgb(166, 167, 173);
    padding: 30px 210px;
    box-sizing: border-box;
    .top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 30px;
      border-bottom: 1px solid #4d4f5c;
      .left {
        display: flex;
        align-items: center;
        text-decoration: none;
        img {
          width: 120px;
          height: 30px;
          margin-right: 16px;
        }
      }
      .right {
        display: flex;
        align-items: center;
        .li {
          color: #212333;
          font-family: '思源黑体';
          font-size: 12px;
          font-weight: 400;
          margin-left: 58px;
          cursor: pointer;
        }
      }
    }
    .bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 30px;
      .left {
        color: #212333;
        font-family: '思源黑体';
        font-size: 10px;
        font-weight: 400;
      }
      .middle {
        // width: 94px;
        color: #1a1c29;
        font-family: '思源黑体';
        font-size: 10px;
        font-weight: 400;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 9px 12px;
        border: 1px solid rgb(77, 79, 92);
        border-radius: 34px;
        box-sizing: border-box;
        line-height: 1;
        cursor: pointer;
        .dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background-color: #006aff;
          margin-right: 8px;
        }
      }
      .right {
        display: flex;
        align-items: center;
        .social-icon {
          display: block;
          width: 18px;
          height: 18px;
          margin-left: 24px;
          cursor: pointer;
          color: #8a94a6;
          transition: color 0.3s ease, transform 0.3s ease;
        }
        .social-icon:hover {
          color: #006aff;
          transform: scale(1.1);
        }
        .social-icon svg {
          width: 100%;
          height: 100%;
          fill: currentColor;
        }
      }
    }
  }
}
</style>
